import script from "./UsuarioCriarEditar.vue?vue&type=script&setup=true&lang=js"
export * from "./UsuarioCriarEditar.vue?vue&type=script&setup=true&lang=js"

import "./UsuarioCriarEditar.vue?vue&type=style&index=0&id=24e8321f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24e8321f"]])

export default __exports__